export * from './home.component';
export * from './home.route';
export * from './home.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/index.ts